/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';
import { CBCRemediationSpecByolCredentials } from './cBCRemediationSpecByolCredentials';
import { CBCRemediationSpecRemediateRegionalCredentials } from './cBCRemediationSpecRemediateRegionalCredentials';


export interface CBCRemediationSpec { 
    spec_type?: ResourceProvider;
    byol_credentials?: CBCRemediationSpecByolCredentials;
    remediate_regional_credentials?: CBCRemediationSpecRemediateRegionalCredentials;
}
export namespace CBCRemediationSpec {
}


